/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".resultSet{margin:5px;padding:5px;border-radius:3px}.resultSet:hover{cursor:pointer!important;background-color:#f8f8f8}.resultSet:focus{background-color:#d3d3d3}"];
export { styles as styles };
